import styles from "./MusicShelfCardWrapper.module.scss";

function MusicShelfCardWrapper(props) {
  return (
    <li className={`${styles["musicCardWrapper"]} flex-center`}>
      {props.children}
    </li>
  );
}

export default MusicShelfCardWrapper;

